import FleetExecutionTask from "./FleetExecutionTask";
import { TaskGroup } from "../../../utils/buildTaskTree";

interface IProps {
  group: TaskGroup;
  fleet_execution_id: string;
  handleViewPopUp: (value: boolean, data: any) => void;
}

export default function FleetExecutionTaskGroup({ group, fleet_execution_id, handleViewPopUp }: IProps) {
  const { parent, children } = group;

  return (
    <>
      {parent && (
        <FleetExecutionTask
          executionTask={parent as any}
          fleet_execution_id={fleet_execution_id}
          handleViewPopUp={handleViewPopUp}
        />
      )}
      {children.map((child) => (
        <FleetExecutionTask
          key={child.fleet_execution_task_id}
          executionTask={{ ...child, is_child: !!parent } as any}
          fleet_execution_id={fleet_execution_id}
          handleViewPopUp={handleViewPopUp}
        />
      ))}
    </>
  );
}
